import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import img1 from "../../Assets/clients/c/sorigin_logo.png";
import img2 from "../../Assets/clients/c/ss_logo.png";
import img3 from "../../Assets/clients/c/atlanta_logo.png";
import img4 from "../../Assets/clients/c/MSEDCL_logo.png";
import img5 from "../../Assets/clients/c/suzlon-logo.png";

import Carousel from "react-bootstrap/Carousel";
import "../../App.css";

function CustomSlider() {
  return (
    <>
      <Container>
        <Row>
          <Col>
            <h4 className="text-center text-danger mt-5">
              SOME OF OUR CLIENTS
            </h4>
          </Col>
        </Row>
      </Container>

      <Carousel variant="dark" className="pb-2" interval={1500} pause={false}>
        <Carousel.Item className="p-lg-2">
          <div className="d-flex justify-content-center align-items-center gap-5 flex-wrap">
            <img
              src={img3}
              style={{ width: "300px" }}
              className="pt-3"
              alt="client-img"
            />

            <img
              src={img1}
              style={{ width: "300px" }}
              className="pt-3"
              alt="client-img"
            />

            <img
              src={img2}
              style={{ width: "300px" }}
              className="pt-3"
              alt="client-img"
            />

            <img
              src={img4}
              style={{ width: "300px" }}
              className="pt-3"
              alt="client-img"
            />
            <img
              src={img5}
              style={{ width: "300px" }}
              className="pt-3"
              alt="client-img"
            />
          </div>
        </Carousel.Item>{" "}
        {/* <Carousel.Item>
          <div className="d-flex justify-content-center align-items-center gap-5 flex-wrap">
            <img
              src={img5}
              style={{ width: "300px" }}
              className="pt-3"
              alt="client-img"
            />
          </div>
        </Carousel.Item> */}
      </Carousel>
    </>
  );
}

export default CustomSlider;
